import { ToastProvider } from '@fiveox/ui'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'

import { router } from './router'
import './styles.css'

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

// Every screen speaks to prodoc-service through `createProDocClient()` — the
// prototype's in-browser mock and its service layer were retired in W6 (T6.30).
createRoot(root).render(
  <StrictMode>
    <ToastProvider>
      <RouterProvider router={router} />
    </ToastProvider>
  </StrictMode>,
)
